/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerSyncQueryResponse, VistaControllerSyncPathParams, VistaControllerSync400, VistaControllerSync401, VistaControllerSync403, VistaControllerSync404 } from "../../models/changeOrdersController/VistaControllerSync";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { vistaControllerSync } from "../../clients/change-ordersService/vistaControllerSync";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const vistaControllerSyncQueryKey = (id: VistaControllerSyncPathParams["id"]) => [{
  url: '/api/v1/potential-change-orders/:id/vista/sync',
  params: {
    id: id
  }
}] as const;
export type VistaControllerSyncQueryKey = ReturnType<typeof vistaControllerSyncQueryKey>;
export function vistaControllerSyncQueryOptions(id: VistaControllerSyncPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = vistaControllerSyncQueryKey(id);
  return queryOptions<VistaControllerSyncQueryResponse, ResponseErrorConfig<VistaControllerSync400 | VistaControllerSync401 | VistaControllerSync403 | VistaControllerSync404>, VistaControllerSyncQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return vistaControllerSync(id, config);
    }
  });
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/sync}
 */
export function useVistaControllerSync<TData = VistaControllerSyncQueryResponse, TQueryData = VistaControllerSyncQueryResponse, TQueryKey extends QueryKey = VistaControllerSyncQueryKey>(id: VistaControllerSyncPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<VistaControllerSyncQueryResponse, ResponseErrorConfig<VistaControllerSync400 | VistaControllerSync401 | VistaControllerSync403 | VistaControllerSync404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? vistaControllerSyncQueryKey(id);
  const query = useQuery({
    ...vistaControllerSyncQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<VistaControllerSync400 | VistaControllerSync401 | VistaControllerSync403 | VistaControllerSync404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}